import {
  AppstoreOutlined,
  AuditOutlined,
  FieldTimeOutlined,
  GlobalOutlined,
  SearchOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Avatar, Button, Image, Layout, Menu, Popover, Tooltip } from "antd";
import { useContext, useEffect, useRef, useState } from "react";
import { FiLogOut, FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import kw from "../../assets/logo-kw.svg";
import { AuthContext } from "../../providers/AuthProvider";
import { useGetMeQuery } from "../../redux/services/users";
import { setOpenSearchBar } from "../../redux/slices/authSlice";
import getTenantId from "../Tenent";
import "./SidePanel.css";
const { Sider } = Layout;

const useClickOutside = (ref, callback) => {
  useEffect(() => {
    const handleClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };
    document.addEventListener("mousedown", handleClick);
    document.addEventListener("touchstart", handleClick);
    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("touchstart", handleClick);
    };
  }, [ref, callback]);
};

// GHG Sidebar Items
const ghgSidebarItems = () => [
  {
    label: "Emissions",
    key: "emission-activities",
    children: [
      // {
      //   label: "Upload Data",
      //   key: "/emission-activities/uploads",
      // },
      {
        label: "View Data",
        key: "/emission-activities",
      },

      // {
      //   label: "Scheduled Emissions",
      //   key: "schedule-calculation",
      //   children: [
      //     {
      //       label: "Employee Commuting",
      //       key: "/schedule-calculation/employee-commuting",
      //     },
      //     {
      //       label: "Electricity",
      //       key: "/schedule-calculation/electricity",
      //     },
      //   ],
      // },

      // {
      //   label: "Raise Data Requests",
      //   key: "/maker-checker/raiseRequests",
      // },
      {
        label: "Add Data",
        key: "/maker-checker/submitter",
      },
      // {
      //   label: "Review Data",
      //   key: "/maker-checker/approvers",
      // },
      // {
      //   label: "Optimize Results",
      //   key: "/emission-activities/optimize",
      // },

      // {
      //   label: "Manage Data",
      //   key: "/maker-checker/requests",
      // },
    ],
  },
  {
    label: "Analytics",
    key: "/analytics",
    children: [
      {
        label: "Dashboard",
        key: "/dashboard",
      },
      // {
      //   label: "Insights",
      //   key: "/emission-insights",
      // },
    ],
  },
  // {
  //   label: "Operational Data",
  //   key: "operational-data",
  //   children: [
  //     {
  //       label: "Production",
  //       key: "/master/products",
  //     },
  //
  //   ],
  // },

  {
    label: "Targets",
    key: "target-emission",
    children: [
      {
        label: "Targets Management Hub",
        key: "/createtarget",
      },
    ],
  },
  {
    label: "Reports",
    key: "/reports",
    children: [
      {
        label: "Activity Reports",
        key: "/reports/type/activity/create",
      },
      {
        label: "PCF",
        key: "/reports/pcf",
      },
      {
        label: "ISO 14064",
        key: "/reports/type/GHG/create",
      },
      {
        label: "GHG Protocol",
        key: "/reports/GHG",
      },
      {
        label: "Embodied Carbon",
        key: "/reports/embodied-carbon-report",
      },
    ],
  },

  {
    label: "Suppliers",
    key: "supplier-engagement",
    children: [
      {
        label: "PCF Management",
        key: "/supplier-engagement",
      },
    ],
  },
  {
    label: "Configurations",
    key: "admin",
    children: [
      {
        label: "Configure Roles",
        key: "/configureRoles",
      },
      {
        label: "Configure Activities",
        key: "/maker-checker/configureActivities",
      },
      {
        label: "Configure Categories",
        key: "/admin/categories",
      },
      {
        label: "Uncertainty Analysis",
        key: "/information/uncertainty-analysis",
      },
      {
        label: "Activity logs",
        key: "/information/activity-logs?tab=emissionlogs",
      },
      {
        label: "Base Metrics",
        key: "/information/base-metrics",
      },
      {
        label: "Accuracy Checker",
        key: "/assurance-module",
      },
      // {
      //   label: "Maker-Checker",
      //   key: "Maker-Checker",
      //   children: [
      //     {
      //       label: "Data Ownership Matrix",
      //       key: "/maker-checker/pocMatrix",
      //     },
      //     {
      //       label: "Category Activities",
      //       key: "/maker-checker/configureActivities",
      //     },
      //   ],
      // },
    ],
  },
  {
    label: "PCF",
    key: "pcf",
    children: [
      {
        label: "PCF",
        key: "/pcf-management",
      }
    ]
  }
];

const getSidebarItems = (modules = {}, activeModule) => {
  let moduleData = modules[activeModule];

  if (!moduleData) return [];

  return Object.entries(moduleData)
    .filter(([name, value]) => name !== "Home")
    .filter(([name, value]) => typeof value !== "number")
    .sort(([, a], [, b]) => {
      return (a._group_id ?? 0) - (b._group_id ?? 0);
    })
    .map(([groupName, groupData]) => {
      const menuMap = {};

      Object.entries(groupData)
        .filter(([name, value]) => typeof value !== "number")
        .sort(([, a], [, b]) => {
          return (a[0][0]._subgroup_id ?? 0) - (b[0][0]._subgroup_id ?? 0);
        })
        .forEach(([submenuName, submenuValue]) => {
          const routes = Array.isArray(submenuValue?.[0])
            ? [...submenuValue[0]]
            : [];

          const sidePanelRoute = routes.find((r) => r.is_side_panel)?.route;

          if (submenuName.includes("/")) {
            const [parent, child] = submenuName.split("/");

            menuMap[parent] ??= {
              label: parent,
              key: parent,
              children: [],
            };

            menuMap[parent].children.push({
              label: child,
              key: sidePanelRoute,
            });
          } else {
            menuMap[submenuName] = {
              label: submenuName,
              key: sidePanelRoute,
            };
          }
        });

      return {
        label: groupName,
        key: groupName,
        children: Object.values(menuMap),
      };
    });
};

// ESG Sidebar Items
const esgSidebarItems = [
  {
    label: "Home",
    key: "/home",
  },
  { type: "divider" },
  {
    label: "Framework & Setup",
    key: "esg-framework",
    children: [
      {
        label: "Metrics Management",
        key: "/esg/metric",
      },
      {
        label: "Target Settings",
        key: "/esg/targets",
      },
    ],
  },
  {
    label: "Data Collection Hub",
    key: "esg-data",
    children: [
      {
        label: "Projects Data",
        key: "/esg/projects",
      },
      {
        label: "Supplier Data",
        key: "/supplier",
      },
      {
        label: "Environmental Data",
        key: "/esg/environmental",
      },
      {
        label: "Social Data",
        key: "/esg/social",
      },
      {
        label: "Governance Data",
        key: "/esg/governance",
      },
    ],
  },
  {
    label: "Visualization",
    key: "esg-visualization",
    children: [
      {
        label: "Dashboard",
        key: "/esg/new/dashboard",
      },
      {
        label: "Reports",
        key: "/esg/reports",
      },
      {
        label: "Predictive Analytics",
        key: "/analytics/predictive",
      },
      {
        label: "Machine Learning",
        key: "/analytics/ml",
      },
      {
        label: "Real-time Monitoring",
        key: "/analytics/realtime",
      },
    ],
  },
];

const newModuleSidebarItems = (tenantId) => [
  {
    label: <span className="esg-home-item">Home</span>,
    key: "/esg/home",
  },
  { type: "divider" },
  {
    label: "Configuration",
    key: "esg-framework",
    children: [
      {
        label: "Metrics Management",
        key: "/esg/metricmanagment",
      },
      {
        label: "Data Ownership Matrix",
        key: "/esg/new/poc",
      },
    ],
  },
  {
    label: "Data",
    key: "esg-data",
    children: [
      {
        label: "Control Center",
        key: "/esg/metricdata?view=maker-checker",
      },
      {
        label: "Raise Requests",
        key: "/esg/raiserequest",
      },
      {
        label: "Track Requests",
        key: "/esg/poc/approver",
      },
      {
        label: "Data Summary",
        key: "/esg/projects/detail/:projectId",
      },
      {
        label: "Upload Data",
        key: "/esg/metricdata?view=upload",
      },
    ],
  },
  {
    label: "Analytics",
    key: "esg-visualization",
    children: [
      {
        label: "Dashboard",
        key: "/esg/new/dashboard",
      },
      {
        label: "Configure Dashboard",
        key: "/esg/config/dashboard",
      },
      {
        label: "Reports",
        key: "/esg/reports",
      },
    ],
  },
];

const cctsSidebarItems = [
  {
    label: "Dashboard",
    key: "/ccts/dashboard",
  },
  {
    label: "Organization Details",
    key: "/ccts/org-details",
  },
  {
    label: "Calculation Engine",
    key: "calculation-engine",
    children: [
      {
        label: "Batch Information",
        key: "/ccts/create",
      },
      {
        label: "Upload Data",
        key: "/ccts/upload-data",
      },
    ],
  },
];

// CBAM Sidebar Items
const cbamSidebarItems = [
  {
    label: "Create CBAM Disclosure",
    key: "/cbam/create-disclosure",
  },
  {
    label: "Fuel, Energy and Production Logs",
    key: "/cbam/fuel-energy-logs",
  },
  {
    label: "Supplier Outreach",
    key: "/cbam/supplier-outreach",
  },
  {
    label: "CBAM Liability",
    key: "/cbam/liability",
  },
];

// Settings Sidebar Items - Common across all tenants
const settingsSidebarItems = (roleId) => [
  {
    label: "Admin",
    key: "user-management",
    children: [
      { label: "Users", key: "/information/users" },
      { label: "Roles & Permissions", key: "/information/admin" },
      ...(roleId === 1
        ? [
            {
              label: "Module Selection",
              key: "/information/admin/module-selection",
            },
          ]
        : []),
    ],
  },
  {
    label: "Organization",
    key: "organization",
    children: [
      {
        label: "Configuration",
        key: "/category-configuration/tenant-configuration",
      },
      {
        label: "Hierarchy",
        key: "/category-configuration/org-hierarchy",
      },
    ],
  },
  
];

const SidePanel = () => {
  const [activePanel, setActivePanel] = useState("");
  const [secondPanelCollapsed, setSecondPanelCollapsed] = useState(true);

  const [hideNavItems, setHideNavItems] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { handleLogout } = useContext(AuthContext);
  const { data: meData } = useGetMeQuery();
  const roleId = useSelector((state) => state.auth.roleId);
  const dispatch = useDispatch();

  const moduleRoutes = useSelector((state) => state.auth.moduleRoutes);

  Object.entries(moduleRoutes).sort(
    ([, a], [, b]) => a._module_order_id - b._module_order_id,
  );

  // Refs for panels
  const firstPanelRef = useRef(null);
  const secondPanelRef = useRef(null);

  const tenantId = getTenantId();
  const handleMenuClick = (item) => {
    if (typeof item.key === "string" && item.key.startsWith("/")) {
      navigate(item.key);
      setSecondPanelCollapsed(true);
    }
  };

  const getShouldShowNewModule = () => {
    return (
      tenantId === "stage" ||
      tenantId === "showcase" ||
      tenantId === "trial" ||
      tenantId === "viyash" ||
      tenantId === "demo" ||
      tenantId === "bvk"
    );
  };

  const getShouldShowCBAM = () => {
    return ["demo", "showcase", "stage", "vulkan", "nuevosol", "trial", "bvk"].includes(tenantId);
  };

  const getShouldShowModule = (moduleName, roleId) => {
    if (roleId === 1) {
      return true;
    }
    return moduleRoutes[moduleName] ? true : false;
  };

  const shouldShowGHG = getShouldShowModule("GHG", roleId);
  const shouldShowESG = getShouldShowModule("ESG", roleId);
  const shouldShowCCTS = getShouldShowModule("CCTS", roleId);
  const shouldShowNewModule = getShouldShowNewModule();
  const shouldShowSettings = getShouldShowModule("Settings", roleId);
  const shouldShowCBAM = getShouldShowCBAM();
  const isAllowed = roleId === 1;

  const handlePanelSelect = (panelType) => {
    if (activePanel === panelType) {
      setSecondPanelCollapsed(!secondPanelCollapsed);
    } else {
      setActivePanel(panelType);
      setSecondPanelCollapsed(false);
    }
    if (panelType === "cbam") {
      navigate("/cbam");
    }
  };

  const getMenuItems = () => {
    switch (activePanel) {
      case "ghg":
        return !isAllowed
          ? getSidebarItems(moduleRoutes, "GHG")
          : ghgSidebarItems();
      case "esg":
        return !isAllowed
          ? getSidebarItems(moduleRoutes, "ESG")
          : esgSidebarItems;
      case "new-module":
        return newModuleSidebarItems(tenantId);
      case "ccts":
        return !isAllowed
          ? getSidebarItems(moduleRoutes, "CCTS")
          : cctsSidebarItems;
      case "cbam":
        return cbamSidebarItems;
      case "settings":
        return !isAllowed
          ? getSidebarItems(moduleRoutes, "Settings")
          : settingsSidebarItems(roleId);
      default:
        return [];
    }
  };

  const getPanelClass = () => {
    switch (activePanel) {
      case "ghg":
        return "ghg-panel";
      case "esg":
        return "esg-panel";
      case "new-module":
        return "analytics-panel";
      case "ccts":
        return "ccts-panel";
      case "cbam":
        return "cbam-panel";
      case "settings":
        return "settings-panel";
      default:
        return "";
    }
  };

  const handleCollapseToggle = () => {
    setSecondPanelCollapsed(!secondPanelCollapsed);
  };

  // Click outside handler
  const handleClickOutside = () => {
    if (!secondPanelCollapsed) {
      setSecondPanelCollapsed(true);
    }
  };

  // Use the click outside hook for second panel
  useClickOutside(secondPanelRef, handleClickOutside);

  // Don't close when clicking on first panel
  const handleFirstPanelClick = (event) => {
    event.stopPropagation();
  };

  return (
    <>
      {/* First Panel - Fixed, Always Visible */}
      <Sider
        className="first-panel"
        width={60}
        theme="light"
        ref={firstPanelRef}
        onClick={handleFirstPanelClick}
      >
        {/* Logo Section */}
        <div className="logo-section">
          <Link to="/">
            <Image src={kw} preview={false} className="logo-image" />
          </Link>
        </div>

        <div
          className="logo-section"
          onClick={() => dispatch(setOpenSearchBar(true))}
        >
          <Button className="nav-button icon-text-button">
            <SearchOutlined />
          </Button>
        </div>

        {/* Main Navigation Buttons */}
        <div className="navigation-buttons">
          {/* GHG Button */}
          {shouldShowGHG && (
            <Button
              type={activePanel === "ghg" ? "primary" : "text"}
              onClick={() => handlePanelSelect("ghg")}
              className={`nav-button icon-text-button ${
                activePanel === "ghg" ? "nav-button-active" : ""
              }`}
            >
              <FieldTimeOutlined className="nav-icon" />
              <span className="nav-button-text">GHG</span>
            </Button>
          )}

          {/* ESG Button (Conditional) */}
          {shouldShowESG && !shouldShowNewModule && (
            <Button
              type={activePanel === "esg" ? "primary" : "text"}
              onClick={() => handlePanelSelect("esg")}
              className={`nav-button icon-text-button ${
                activePanel === "esg" ? "nav-button-active" : ""
              }`}
            >
              <AppstoreOutlined className="nav-icon" />
              <span className="nav-button-text">ESG</span>
            </Button>
          )}

          {/* New Module (Advanced Analytics) */}
          {shouldShowESG && shouldShowNewModule && (
            <Button
              type={activePanel === "new-module" ? "primary" : "text"}
              onClick={() => handlePanelSelect("new-module")}
              className={`nav-button icon-text-button ${
                activePanel === "new-module" ? "nav-button-active" : ""
              }`}
            >
              <AppstoreOutlined className="nav-icon" />
              <span className="nav-button-text">ESG</span>
            </Button>
          )}

          {/* CCTS Button */}
          {shouldShowCCTS && (
            <Button
              type={activePanel === "ccts" ? "primary" : "text"}
              onClick={() => handlePanelSelect("ccts")}
              className={`nav-button icon-text-button ${
                activePanel === "ccts" ? "nav-button-active" : ""
              }`}
            >
              <AuditOutlined className="nav-icon" />
              <span className="nav-button-text">CCTS</span>
            </Button>
          )}

          {/* CBAM Button */}
          {shouldShowCBAM && (
            <Button
              type={activePanel === "cbam" ? "primary" : "text"}
              onClick={() => handlePanelSelect("cbam")}
              className={`nav-button icon-text-button ${
                activePanel === "cbam" ? "nav-button-active" : ""
              }`}
            >
              <GlobalOutlined className="nav-icon" />
              <span className="nav-button-text">CBAM</span>
            </Button>
          )}

          {/* Settings Button - Always visible */}
          {shouldShowSettings && (
            <Button
              type={activePanel === "settings" ? "primary" : "text"}
              onClick={() => handlePanelSelect("settings")}
              className={`nav-button icon-text-button ${
                activePanel === "settings" ? "nav-button-active" : ""
              }`}
            >
              <SettingOutlined className="nav-icon" />
              <span className="nav-button-text">
                <SettingOutlined />
              </span>
            </Button>
          )}
        </div>

        {/* User Avatar + Logout */}
        <div className="logout-section">
          <Popover
            placement="rightBottom"
            trigger="hover"
            content={
              <div style={{ minWidth: 180 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <UserOutlined style={{ fontSize: 14 }} />
                  <div style={{ fontWeight: 600, fontSize: 14 }}>
                    {meData?.first_name} {meData?.last_name}
                  </div>
                </div>
                <div style={{ color: "#666", fontSize: 12, marginTop: 2 }}>
                  {meData?.email}
                </div>
                <div
                  style={{
                    color: "#00984a",
                    fontSize: 12,
                    marginTop: 4,
                    fontWeight: 500,
                  }}
                >
                  {meData?.role_name}
                </div>
              </div>
            }
          >
            <Avatar
              className="user-avatar"
              size={36}
              style={{ cursor: "pointer" }}
            >
              {meData?.first_name?.charAt(0)?.toUpperCase() ||
                meData?.email?.charAt(0)?.toUpperCase()}
            </Avatar>
          </Popover>
          <Tooltip title="Logout" placement="right">
            <Button
              className="logout-button"
              icon={<FiLogOut />}
              onClick={handleLogout}
            />
          </Tooltip>
        </div>
      </Sider>

      {/* Second Panel - Only show when there's an active panel AND nav is not hidden */}
      {!hideNavItems && activePanel && (
        <Sider
          className={`second-panel ${getPanelClass()} ${
            secondPanelCollapsed ? "second-panel-collapsed" : ""
          }`}
          width={260}
          collapsed={secondPanelCollapsed}
          collapsedWidth={0}
          theme="light"
          style={{
            left: 60,
            position: "fixed",
            height: "100vh",
            zIndex: 998,
          }}
          ref={secondPanelRef}
        >
          {/* Panel Header */}
          {!secondPanelCollapsed ? (
            <div className="second-panel-header expanded-header">
              <div className="panel-title-section">
                <h4 className="panel-title">
                  {{
                    ghg: "GHG Module",
                    esg: "ESG Module",
                    ccts: "CCTS Module",
                    "new-module": "Advanced Analytics",
                    cbam: "CBAM Module",
                    settings: "Settings",
                  }[activePanel] || ""}
                </h4>
              </div>
              <Tooltip title="Collapse sidebar" placement="bottom">
                <Button
                  type="text"
                  icon={<FiX />}
                  onClick={handleCollapseToggle}
                  className="panel-toggle-btn"
                />
              </Tooltip>
            </div>
          ) : (
            <div className="second-panel-header collapsed-header"></div>
          )}

          {/* Menu Content */}
          <div
            className={`menu-content ${
              secondPanelCollapsed ? "menu-content-collapsed" : ""
            }`}
          >
            {secondPanelCollapsed ? (
              <div className="collapsed-menu">
                {getMenuItems().map((item, index) => (
                  <Tooltip
                    key={item.key || index}
                    title={item.label}
                    placement="right"
                  >
                    <Button
                      type="text"
                      className="collapsed-menu-item"
                      onClick={() => {
                        if (item.children && item.children.length > 0) {
                          setSecondPanelCollapsed(false);
                        } else if (item.key) {
                          handleMenuClick(item);
                        }
                      }}
                    />
                  </Tooltip>
                ))}
              </div>
            ) : (
              <Menu
                mode="inline"
                selectedKeys={[location.pathname]}
                items={
                  {
                    ghg: !isAllowed
                      ? getSidebarItems(moduleRoutes, "GHG")
                      : ghgSidebarItems(),
                    esg: !isAllowed
                      ? getSidebarItems(moduleRoutes, "ESG")
                      : esgSidebarItems,
                    ccts: !isAllowed
                      ? getSidebarItems(moduleRoutes, "CCTS")
                      : cctsSidebarItems,
                    cbam: cbamSidebarItems,
                    "new-module": newModuleSidebarItems(tenantId),
                    settings: !isAllowed
                      ? getSidebarItems(moduleRoutes, "Settings")
                      : settingsSidebarItems(roleId),
                  }[activePanel] || []
                }
                onClick={handleMenuClick}
                className="navigation-menu"
              />
            )}
          </div>
        </Sider>
      )}
    </>
  );
};

export default SidePanel;
